var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var directives;
    (function (directives) {
        var ReportForm = /** @class */ (function (_super) {
            __extends(ReportForm, _super);
            function ReportForm() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.templateUrl = './app/views/directives/inputForm/reportForm.html';
                _this.controller = [
                    '$scope', 'angularLoadService', 'formSectionService', 'ModalService', '$http',
                    'dataSourceService', 'formService', 'formDataService', 'growl', 'formCodeFunctionService',
                    'customDivService', 'apiActionService', 'securityMatrixService', 'deleteService', ReportFormController
                ];
                return _this;
            }
            return ReportForm;
        }(directives.BaseForm));
        directives.ReportForm = ReportForm;
        var ReportFormModel = /** @class */ (function (_super) {
            __extends(ReportFormModel, _super);
            function ReportFormModel() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            ReportFormModel.prototype.setupImplementedForm = function () {
                if (this.internalSetupForm()) {
                    //this.addPanelGroup();
                    this.save();
                }
            };
            return ReportFormModel;
        }(directives.BaseOnePageFormModel));
        directives.ReportFormModel = ReportFormModel;
        var ReportFormController = /** @class */ (function (_super) {
            __extends(ReportFormController, _super);
            function ReportFormController(scope, angularLoader, formSectionService, modalService, httpService, dataSourceService, formService, formDataService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiConfigurationService, securityMatrixService, deleteService) {
                var _this = this;
                scope.model = new ReportFormModel(angularLoader, formSectionService, modalService, httpService, dataSourceService, formService, scope.process, formDataService, growl, formCodeFunctionService, customDivService, manageProcessDataConfigurationService, apiConfigurationService, securityMatrixService, deleteService, scope);
                _this = _super.call(this, scope) || this;
                return _this;
            }
            return ReportFormController;
        }(directives.BaseFormController));
        directives.ReportFormController = ReportFormController;
    })(directives = warsApp.directives || (warsApp.directives = {}));
})(warsApp || (warsApp = {}));
warsApp.registerDirective('ReportForm', []);
